export default __webpack_public_path__ + "static/media/responsive.28d90a84.gif";